module.exports = String.fromCharCode
